var chunkToChildrenMap = {
	"918": [
		1641,
		1962
	],
	"1199": [
		1641,
		1962
	],
	"7856": [
		1641,
		1962
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));